import React, { Component } from 'react';
import axios from 'axios'

import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';

import withStyles from '@mui/styles/withStyles';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import { withTranslation } from 'react-i18next';

const styles = theme => ({
    root: {
        '& .MuiTextField-root': {
            margin: '8px',
            width: '40ch',
            minWidth: '25ch',
            maxWidth: '90%'
        },
    },
});

class ForgotPassword extends Component {
    constructor(props) {
        super(props)
        this.state = {
            username: this.props.location.state.username ,
            error: null,
            sent : false
        };
    }
    

    handleChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    onSubmit = (event) => {
        let data = {
            username: this.state.username
        }
        console.log('username', this.state.username)
        axios.post('/api/user/forgotPassword', data).then((res) => {
            console.log(res);
            if (res.status === 200) {
                this.setState({
                    sent : true
                })

                setTimeout(() => this.setState({ sent : false }), 5000 );
            } else {
                const error = new Error(res.error);
                throw error;
            }
        })
            .catch(error => {
                console.log("error:" + error);
                this.setState({
                    error: error.message
                });
            });
    }

    onCancel = (event) => {
        this.props.history.goBack();
    }


    hideError = () => {
        this.setState({ error: '' })
    }

    render() {
        const { classes } = this.props;

        

        return (
            <ValidatorForm
                noValidate
                onSubmit={this.onSubmit}
            >
                {this.state.error &&
                    <div>
                        <Alert severity="error" onClose={this.hideError}>{this.state.error}</Alert>
                        <br />
                    </div>
                }

                {this.state.sent &&
                    <div>
                        <Alert severity="success" onClose={this.hideError}> Successfully sent an email, please check your inbox </Alert>
                        <br />
                    </div>
                }

                <div className={classes.root} style={{ textAlign: 'center' }}>
                    <h3> {this.props.t('UserProfile.ResetPassword')} </h3>
                    <br />

                        <TextValidator
                            id="username"
                            label= "Username"
                            type="text"
                            className={[].join(' ')}
                            onChange={this.handleChange}
                            value={this.state.username}
                            validators={['required']}
                            errorMessages={['Username is required']}
                            name='username'
                            required
                        />

                    <br />

                    <Button variant="contained" style={{ whiteSpace: 'nowrap', width: 'fit-content' }} type="submit" color="primary" className={[].join(' ')} > Send email to reset password </Button>
                    <br /><br />
                    <Button variant="outlined" className={[].join(' ')} onClick={this.onCancel}> Back </Button>
                </div>
            </ValidatorForm>
        );
    }
}

// export default Login;
export default withStyles(styles, { withTheme: true })(withTranslation()(ForgotPassword));


// export default ForgotPassword